/*
  Judge.me review widget laid out like Ruggable's reviews (owner, 16 Oct 2026), on every product page.
  Loaded by sections/apps.liquid in the reviews_app section on product templates, with pdp-reviews-all.css.
  - Header (compact since 1 Nov 2026): stars and "{count} Reviews" in one row. The chevron opens the rating
    breakdown (Judge.me's own histogram, still clickable); the round button opens the tools row below.
    The Write a review button sits under the row. The photo gallery is hidden in pdp-reviews.css.
  - "Photo Gallery": customer photos in one row that scrolls sideways, with a next arrow.
  - One tools row: search, a Rating filter (uses Judge.me's histogram filter) and Sort by on the right.
  - Clicking a star rating link anywhere on the page scrolls smoothly to the reviews.
  Only rearranges Judge.me's own elements; reviews, filters and paging stay Judge.me's.
*/
(function () {
  'use strict';
  var STAR = 'M12 2.8l2.75 5.9 6.45.75-4.8 4.4 1.3 6.35L12 17.05 6.3 20.2l1.3-6.35-4.8-4.4 6.45-.75z';

  function stars(r) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var d = r - (i - 1), fill = d >= 0.75 ? 'full' : d >= 0.25 ? 'half' : 'none';
      var id = 'nr-half-' + Math.random().toString(36).slice(2, 8);
      out += '<svg viewBox="0 0 24 24" class="is-' + fill + '" aria-hidden="true"><defs><clipPath id="' + id + '"><rect x="0" y="0" width="12" height="24"/></clipPath></defs><path class="o" d="' + STAR + '"/>' + (fill === 'half' ? '<path class="f" clip-path="url(#' + id + ')" d="' + STAR + '"/>' : '') + '</svg>';
    }
    return out;
  }

  function panel(btn, el) {
    if (!btn || btn._nrPanel) return;
    btn._nrPanel = true;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      el.hidden = !open;
    });
  }

  /* Two steps (owner, 1 Nov 2026: stars and header missing on a real phone).
     1. The header is built straight away from the rating and count Judge.me prints in the page, so it shows
        even when Judge.me's script is slow or stalls on a phone.
     2. Judge.me's own parts (breakdown bars, Write a review, search, sort) are moved in once Judge.me has
        finished setting up. Returns true when both steps are done. */
  function build(sec) {
    var w = sec.querySelector('.jdgm-rev-widg');
    if (!w) return false;
    var header = w.querySelector('.jdgm-rev-widg__header');
    if (!header) return false;

    /* Step 1. Checked by the header itself, not a flag: if Judge.me redraws its widget, the header is gone
       and gets built again (watch() below). */
    var head = w.querySelector('.nr-head');
    if (!head) {
      var oldTools = w.querySelector('.nr-tools');
      if (oldTools) oldTools.parentNode.removeChild(oldTools);
      var n = parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0;
      var avg = parseFloat(w.getAttribute('data-average-rating')) || 0;
      /* Compact header (owner, 1 Nov 2026, Melo Sleep reference): one row with stars, "{count} Reviews" and a
         chevron that opens the rating breakdown, and a square button on the right that opens search, rating
         and sort. "Write a review" is a slim outlined button under the row. */
      var uid = Math.random().toString(36).slice(2, 8);
      head = document.createElement('div');
      head.className = 'nr-head nr-head--compact';
      head.setAttribute('data-uid', uid);
      head.innerHTML = '<div class="nr-bar"><div class="nr-stars" role="img" aria-label="' + avg.toFixed(1) + ' out of 5 stars">' + stars(avg) + '</div>' +
        '<h2 class="nr-count"><button type="button" class="nr-toggle" aria-expanded="false" aria-controls="nr-break-' + uid + '">' + n.toLocaleString('en-US') + (n === 1 ? ' Review' : ' Reviews') +
        '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5L6 8l3.5-3.5"/></svg><span class="nr-vh"> - show rating breakdown</span></button></h2>' +
        '<button type="button" class="nr-tools-btn" aria-expanded="false" aria-controls="nr-tools-' + uid + '" aria-label="Search, filter and sort reviews"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg></button></div>' +
        '<div class="nr-break" id="nr-break-' + uid + '" hidden><p class="nr-avg">' + avg.toFixed(1) + ' out of 5</p></div>' +
        '<div class="nr-write-wrap"><button type="button" class="nr-write">Write a review</button></div>';
      header.insertBefore(head, header.firstChild);
      sec.classList.add('nr-on');
      panel(head.querySelector('.nr-toggle'), head.querySelector('.nr-break'));
      /* Our buttons are there from the first moment so the header never changes shape while Judge.me loads.
         A click before Judge.me is ready is remembered and carried out in step 2. */
      head.querySelector('.nr-write').addEventListener('click', function () {
        var link = head._nrDone && w.querySelector('.jdgm-write-rev-link');
        if (link) link.click(); else head._nrWantWrite = true;
      });
      head.querySelector('.nr-tools-btn').addEventListener('click', function () {
        if (head._nrDone) return;
        head._nrWantTools = !head._nrWantTools;
        this.setAttribute('aria-expanded', head._nrWantTools ? 'true' : 'false');
      });
    }
    if (head._nrDone) return true;

    /* Step 2 */
    var wid = sec.querySelector('.jdgm-widget');
    if (!wid || !wid.classList.contains('jdgm--done-setup-widget')) return false;
    var row = w.querySelector('.jdgm-row-stars') || header;
    var side = head.querySelector('.nr-break');
    var hist = side.querySelector('.jdgm-histogram');
    if (!hist) {
      hist = row.querySelector('.jdgm-histogram');
      if (hist) { hist.classList.remove('jdgm-temp-hidden'); side.appendChild(hist); }
    }

    /* Photo gallery: hidden in the compact design (every card shows its photo). No class is added to the
       gallery's parent any more: before Judge.me wraps the gallery, that parent is the whole header (1 Nov 2026). */

    /* Tools row: search, Rating, Sort by */
    var tbtn = head.querySelector('.nr-tools-btn');
    if (!w.querySelector('.nr-tools')) {
      var tools = document.createElement('div');
      tools.className = 'nr-tools';
      var search = w.querySelector('.jdgm-review-search-wrapper');
      if (search) tools.appendChild(search);
      var rows = hist ? Array.prototype.slice.call(hist.querySelectorAll('.jdgm-histogram__row[data-rating]')) : [];
      if (rows.length) {
        var lab = document.createElement('label');
        lab.className = 'nr-filter';
        var opts = '<option value="">Rating</option>';
        [5, 4, 3, 2, 1].forEach(function (r) {
          var rr = hist.querySelector('.jdgm-histogram__row[data-rating="' + r + '"]');
          var f = rr ? parseInt(rr.getAttribute('data-frequency'), 10) || 0 : 0;
          if (f) opts += '<option value="' + r + '">' + r + ' star' + (r === 1 ? '' : 's') + ' (' + f.toLocaleString('en-US') + ')</option>';
        });
        lab.innerHTML = '<span class="nr-vh">Filter by rating</span><select>' + opts + '</select>';
        var sel = lab.querySelector('select');
        sel.addEventListener('change', function () {
          var v = sel.value;
          var target = v ? hist.querySelector('.jdgm-histogram__row[data-rating="' + v + '"] .jdgm-histogram__star') : hist.querySelector('.jdgm-histogram__clear-filter');
          if (target) target.click();
        });
        tools.appendChild(lab);
      }
      var sort = w.querySelector('.jdgm-rev-widg__sort-wrapper');
      if (sort) { sort.classList.add('nr-sort'); tools.appendChild(sort); }
      var anchor = w.querySelector('.jdgm-rev-widg__body');
      if (anchor && tools.children.length) {
        tools.id = 'nr-tools-' + head.getAttribute('data-uid');
        tools.hidden = true;
        anchor.parentNode.insertBefore(tools, anchor);
        if (tbtn) {
          panel(tbtn, tools);
          if (head._nrWantTools) { tbtn.setAttribute('aria-expanded', 'true'); tools.hidden = false; }
        }
      } else if (tbtn) tbtn.hidden = true;
    }
    head._nrDone = true;
    if (head._nrWantWrite) {
      head._nrWantWrite = false;
      var wl = w.querySelector('.jdgm-write-rev-link');
      if (wl) wl.click();
    }
    if (!w.querySelector('.jdgm-write-rev-link')) {
      var ww = head.querySelector('.nr-write-wrap');
      if (ww) ww.hidden = true;
    }
    return true;
  }

  function nrGlide(target) {
    /* Our own eased scroll (the page cancels native smooth scrolling). target() is read every frame,
       because lazy images and reveal effects above the reviews change the page height mid-scroll. */
    var start = window.scrollY, t0 = null, dur = Math.min(900, 300 + Math.abs(target() - start) / 6);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, target()); return; }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), k = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, start + (target() - start) * k);
      if (p < 1) requestAnimationFrame(step);
      else setTimeout(function () { var t = target(); if (Math.abs(window.scrollY - t) > 4) window.scrollTo(0, t); }, 250);
    }
    requestAnimationFrame(step);
  }
  function scrollToReviews(e) {
    var sec = document.querySelector('[id$="__reviews_app"]');
    if (!sec) return;
    if (e) e.preventDefault();
    var head = document.querySelector('.header-wrapper, header, .site-header');
    var pos = head ? getComputedStyle(head).position : '';
    var off = (pos === 'sticky' || pos === 'fixed') ? head.getBoundingClientRect().height + 12 : 12;
    nrGlide(function () { return Math.max(0, sec.getBoundingClientRect().top + window.scrollY - off); });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.pk__rating-live, .jdgm-preview-badge, a[href="#judgeme_product_reviews"], a[href="#reviews"], [data-nr-reviews-link]');
    if (!link || link.closest('[id$="__reviews_app"]')) return;
    scrollToReviews(e);
  });

  /* Rebuild the header whenever Judge.me redraws its widget, and finish step 2 whenever Judge.me finishes
     setting up (however late), so the section never ends up with an empty space above the cards. */
  function watch(sec) {
    if (sec._nrWatch || !window.MutationObserver) return;
    sec._nrWatch = true;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        var w = sec.querySelector('.jdgm-rev-widg');
        var head = w && w.querySelector('.nr-head');
        if (w && (!head || !head._nrDone)) build(sec);
      }, 150);
    }).observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  function init() {
    document.querySelectorAll('[id$="__reviews_app"]').forEach(function (sec) {
      watch(sec);
      if (build(sec)) return;
      var tries = 0;
      var t = setInterval(function () { tries++; if (build(sec) || tries > 120) clearInterval(t); }, 250);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
